import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Link,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { BreadcrumbSeparator } from "../../customIcons";

export type Breadcrumb = {
  label: string;
  link?: string;
};

type BreadcrumbProps = {
  crumbs: Breadcrumb[];
  px?: any;
};

const Breadcrumbs = ({ crumbs }: BreadcrumbProps) => {
  return (
    <Stack w="100%" bg="#F6FAF9">
      <Breadcrumb
        w="100%"
        maxW="1280px"
        px={{ base: 3, "2xl": 0 }}
        bg="#F6FAF9"
        mx="auto"
        separator={<BreadcrumbSeparator w="6px" h="9px" />}
        mt={{ base: "72px", lg: "88px" }}
        py={2}
      >
        {crumbs.map((crumb, index) => {
          const isLastCrumb = index === crumbs.length - 1;

          return (
            <BreadcrumbItem
              alignItems="center"
              justifyContent="center"
              fontSize="12px"
              key={index}
              className="regular-text"
            >
              <BreadcrumbLink
                as={Link}
                noOfLines={1}
                href={crumb.link}
                color={isLastCrumb ? "#116266" : "#6A7471"}
              >
                {crumb.label}
              </BreadcrumbLink>
            </BreadcrumbItem>
          );
        })}
      </Breadcrumb>
    </Stack>
  );
};

export default Breadcrumbs;
